import IComponent from "components/commons/IComponent";
import DocumentTreeView from "../DocumentTreeView";
import GetArcGISToken from "utils/GetArcGISToken";
class S23Report extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      TreeView: [],
    };
  }
  async componentDidMount() {
    let cachedData = this.props.cachedData;
    if (cachedData) {
      this.setState(cachedData);
      this.props.isShowTabCallback(true);
      return;
    }
    if (this.props.text !== "") {
      let url = `${this.$config.ManMadeSlopeInfoList.S23ReportUrl}`;
      let data = {
        Key: this.props.text,
      };
      var queryTexturalResults;
      try {
        queryTexturalResults = await this.fetchQueryByPOST(url, data);
        var treeViewResult = await queryTexturalResults.json();
        if (treeViewResult) {
          if ([5, 6].includes(GetArcGISToken.user.userGroup)) {
            treeViewResult.forEach((i) => {
              if (i.text.startsWith("S2R")) {
                i.URL = "#";
                i.onclick = (evt) => {
                  this.props.showDialog({
                    isOpen: true,
                    type: "error",
                    title: "Access Denied",
                    content: "The user has no permission to open this report",
                    onDialogOk: () => {},
                  });
                  evt.preventDefault();
                };
              }
            });
          }
          this.props.onCachePanelData(this.props.title, {
            TreeView: treeViewResult,
          });
          if (!treeViewResult.length) this.props.isShowTabCallback(false);
          else {
            this.props.isShowTabCallback(true);
            this.setState({ TreeView: treeViewResult });
          }
        }
      } catch {
        this.props.isShowTabCallback(false);
      }
    }
  }
  componentWillUnmount() {}
  render() {
    return (
      <div>
        <div className="SubPanelTitle">S2/3 Report</div>
        <DocumentTreeView tree={this.state.TreeView} />
      </div>
    );
  }
}

export default S23Report;
